export const TEXT_MANAGE_LICENSES = 'License Management'
